<ng-container *ngIf="popupVisible">
  <dx-popup
    [title]="control?.controlDescription + ' Arama (' + controlName + ')'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="popupVisible"
    (onHiding)="closePopupAfter($event)"
  >
    <div class="ctl-search-area">
      <div class="content" *ngIf="gridControlsList$ | async as gridControlsListItem">
        <div class="first-table-container">
          <dk-dx-data-table2
            [dataSource]="data"
            [columnList]="columns"
            height="100%"
            [columnTransactions]="false"
            [filterValue]="filterValue?filterValue:null"
            [gridCtlList]="gridControlsListItem"
            (focusedRowChanged)="focusChanged($event)"
            (selectedRowData)="selectedRowData($event)"
            [dontSelectDataSource]="true"
            [isGroupingYn]="false"
          >
          </dk-dx-data-table2>
        </div>
      </div>

      <div class="search-btn-area">
        <div>
          <dx-button
            icon="check"
            stylingMode="contained"
            text="Seç"
            type="success"
            [width]="150"
            (onClick)="chooseBtnClick()">
          </dx-button>
        </div>
        <div class="search-right-btn">
          <dx-button
            icon="close"
            stylingMode="contained"
            text="İptal"
            type="danger"
            [width]="150"
            (onClick)="cancelBtnClick()">
          </dx-button>
        </div>
      </div>
    </div>
  </dx-popup>
</ng-container>
